<div class="row kt-p-20">
    <div class="col-auto title">
        <h3>Scraped Page Preview</h3>
    </div>
    <div class="col text-end">
        <button class="btn btn-clear close" (click)="close()" aria-label="Close" title="Close">&times;</button>
    </div>

</div>


  <div class="alert" role="alert">
      <div class="alert-icon">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <rect id="bound" x="0" y="0" width="24" height="24"/>
                  <circle id="Oval-5" fill="#000000" opacity="0.3" cx="12" cy="12" r="10"/>
                  <rect id="Rectangle-9" fill="#000000" x="11" y="10" width="2" height="7" rx="1"/>
                  <rect id="Rectangle-9-Copy" fill="#000000" x="11" y="7" width="2" height="2" rx="1"/>
              </g>
          </svg>
      </div>
      <div class="alert-text">
            This is the raw content of the scraped page, displayed in markdown format as fetched by Charla's web scraper.
            Some elements may appear redundant depending on how the embedding engine processes and optimizes the content.
      </div>
  </div>

<ng-scrollbar style="max-height: 70vh;">
  <div class="content">
    <div [innerHTML]="scraped_page | markdown | async"></div>
  </div>
</ng-scrollbar>
